<div
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="20px">
  <mg-text
    class="title"
    fontWeight="900"
    textAlign="center"
    >{{ MSG.ERROR_500_TITLE }}</mg-text
  >
  <img [src]="MSG.ERROR_500_IMAGE" />
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="12px">
    <mg-text
      variant="header-md"
      textAlign="center">
      {{ MSG.ERROR__500_QUOTE }}
    </mg-text>
    <mg-text
      variant="body"
      textAlign="center"
      >{{ MSG.ERROR_500_DESCRIPTION }}</mg-text
    >
  </div>
</div>
